<template>
    <h1>Generowanie raportu</h1>

    <div class="report-container">
        <VeeForm v-if="loaded" @submit="downloadReport" @keydown.enter="$event.preventDefault()"
                 v-slot="{ errors }" class="form">
            <div class="field">
                <EonTimePicker width="300" label="Data rozpoczęcia" name="pickerStart"
                               v-model="report.start" :show-time="false" rules="required"/>
            </div>
            <div class="field">
                <EonTimePicker width="300" label="Data zakończenia" name="pickerEnd"
                               v-model="report.end" :show-time="false" rules="required"/>
            </div>
            <div class="field">
                <EonMultiSelectVoltageLevel name="voltage" v-model="report.voltageLevels"
                                            label="Napięcie" width="300" rules="notEmpty"/>
            </div>
            <div class="buttons">
                <EonButton extension="50" label="Pobierz raport" icon="pi pi-download"
                           :disabled="isDisabled(errors)"/>
            </div>
        </VeeForm>
    </div>

</template>

<script>

    import {Form as VeeForm} from "vee-validate";
    import EonButton from "@/components/form/EonButton";
    import {FileUtils} from "@/utils/FileUtils";
    import EonOutlinedButton from "@/components/form/EonOutlinedButton";
    import EonTimePicker from "@/components/form/EonTimePicker";
    import EonCheckbox from "@/components/form/EonCheckbox";
    import EonSelectOne from "@/components/form/EonSelectOne";
    import EonMultiSelectVoltageLevel from "@/components/form/EonMultiSelectVoltageLevel";

    export default {
        name: "UserReportView",

        props: {
            modelValue: null,
        },

        data() {
            return {
                loaded: true,
                report: {
                    start: null,
                    end: null,
                    voltageLevels: [],
                },
            };
        },

        methods: {
            downloadReport() {
                // eslint-disable-next-line max-len
                FileUtils.downloadFileUsingPOST("Planowane wyłączenie.xlsx", "/api/planned-outage/report", this.report);
            },
            isDisabled(errors) {
                return (!(errors && Object.keys(errors).length === 0
                    && Object.getPrototypeOf(errors) === Object.prototype));
            },
        },

        components: {
            EonMultiSelectVoltageLevel,
            VeeForm,
            EonSelectOne,
            EonCheckbox,
            EonTimePicker,
            EonOutlinedButton,
            EonButton,
        },
    };
</script>

<style lang="less" scoped>
.report-container {
    width: 100%;
    display: flex;
    gap: 2%;
    justify-content: center;
    margin-bottom: 40px;
    margin-top: 40px;
    .input-width-set {
        width: 510px;
        @media screen and (max-width: 1480px) {
            width: 80%;
        }
    }
    .form {
        width: 42%;
        .buttons {
            display: flex;
            justify-content: center;
            gap: 40px;
            margin-top: 80px;
        }
        .field {
            gap: 0;
            align-items: center;
            justify-content: center;
        }
    }
}
</style>
